module.exports = __webpack_public_path__ + "media/images/teams/ATALANTA-a8ea507506477436b00391e355853d88.png";